/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  FaUserAlt,
  // FaChartLine,
  FaAngleLeft,
  FaAngleRight,
} from "react-icons/fa";
import {
  BsFillBriefcaseFill,
  BsFillBarChartFill,
  BsFillBuildingsFill,
  BsCalendarPlus,
} from "react-icons/bs";
import { RiAdminFill } from "react-icons/ri";
import style from "./sidenavbar.module.scss";
import { FaChalkboardUser } from "react-icons/fa6";
import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import SidebarMenu from "./sidebarMenu";
import Taizologo from "../../../assets/images/taizo-logo-img-_footer.svg";
import { AppBar, Tooltip, tooltipClasses } from "@mui/material";
import Box from "@mui/material/Box";
import { Toolbar } from "@mui/material";
import { Typography } from "@mui/material";
import { IconButton } from "@mui/material";
// import {} from '@mui/icons-material';
import { MenuItem } from "@mui/material";
import { Menu } from "@mui/material";
import Notification from "../../notifications";
import "../../commonactive.css";
// import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import ToggleSwitch from "../../Toggle/Toggle";
import { Avatar } from "@material-ui/core";
import styled from "styled-components";
import { VscDebugConsole } from "react-icons/vsc";
import { PiTreeStructureBold } from "react-icons/pi";
import { MdSendToMobile } from "react-icons/md";
import TeamMemberActionList from "../../../pages/TeamLeader/TeamMemberActionList";
import { dateFormate, decryptedAdminID, getPercentageColor, MyModal } from "../../../utility";
import ModalContainer from "../../modal_popup";
import { AiOutlineClose } from "react-icons/ai";
import TeamMemberActionTable from "../../../pages/TeamLeader/TeamMemberActionTable";
import { CandidatePipelineActions } from "../../../redux-store/store";
import { useDispatch } from "react-redux";
import { getTargetData } from "../../../apiServices";
import { HiOutlineRefresh } from "react-icons/hi";
import { GiCheckboxTree } from "react-icons/gi";

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip arrow {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    padding: "10px",
    marginLeft: "15px",
    fontSize: "14px",
    backgroundColor: "#169c50",
    color: "#fff",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#169c50",
  },
});
const SideNavbar = ({ children }) => {
  const adminDetails = useSelector((state) => state.adminDetails);
  const mothlyTargetFilter = useSelector(
    (state) => state.CandidateDashboardFilterDetails.AdminMonthlyTarget
  );
  const adminAccess = useSelector((state) => state.RolesAndAccessDetails);
  const isTeamLeader = localStorage.getItem("teamLeader");
  const [openTeamList, setOpenTeamList] = useState(false);

  let employerList = [
    "Employer Leads",
    "Employer Registered",
    "Employer KYC",
    "Employer Enquiry",
  ];

  let midSeniorList = [
    "Mid senior Candidate Sourcing",
    "Mid senior Candidate Lead",
    "Mid senior Candidate Screening",
    "Mid senior Candidate Resource",
  ];

  let jobList = ["Jobs", "Jobs Leads"];

  let candidateList = [
    "Candidate funnel",
    "Candidate Meta leads",
    "Candidate Leads",
    "Candidate Registered",
    "Candidate Interviews",
    "Candidate Joined",
  ];
  let inVoiceList = ["Invoice"];

  let adminAnalyticsList = ["Bar view"];

  let adminconfigList = ["Add job role,Add key skill"];

  let adminAccessList = adminAccess.accessNames;

  // function arraysHaveSimilarElements(arr1, arr2) {
  //   // Using the some method to iterate over arr1 and check if any element is present in arr2
  //   return arr1.some((item) => arr2.includes(item));
  // }

  function arraysHaveSimilarElements(arr1, arr2) {
    if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
      console.error("One or both arguments are not arrays", { arr1, arr2 });
      return false;
    }

    return arr1.some((item) => arr2.includes(item));
  }

  // eslint-disable-next-line eqeqeq
  let isSuperAdmin = adminDetails.roleID == 1;
  let invoiceAdmin = decryptedAdminID();
  let ProfilePic = adminDetails.ProfilePic;
  const initials = adminDetails.userName
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase();

  const routes = [
    {
      path: "/CandidatePipelineTab",
      name: "Pipeline",
      icon: <PiTreeStructureBold />,
      exact: true,
    },
    {
      path: "/NewCandidatePipelineTab",
      name: "New Pipeline",
      icon: <GiCheckboxTree/>,
      exact: true,
    },
    //  {
    //   path: "/NewFollowUp",
    //   name: "New Followup",
    //   icon: <BsCalendarPlus />,
    //   exact: true,
    // },
    isSuperAdmin && {
      path: "/superAdminTab",
      name: "Super Admin",
      icon: <RiAdminFill />,
      exact: true,
    },
    arraysHaveSimilarElements(adminAccessList, adminAnalyticsList) && {
      path: "/superAdminAnalytics",
      name: "Analytics",
      icon: <BsFillBarChartFill />,
      exact: true,
    },

    arraysHaveSimilarElements(adminAccessList, candidateList) && {
      path: "/CandidateTabsview",
      name: "Candidate",
      icon: <FaUserAlt />,
      exact: true,
    },
    // arraysHaveSimilarElements(adminAccessList, midSeniorList) && {
    //   path: "/MidLevelSenior",
    //   name: "Mid/Senior Level",
    //   icon: <HiOutlineUserGroup />,
    //   exact: true,
    // },
    arraysHaveSimilarElements(adminAccessList, employerList) && {
      path: "/EmployerTabsview",
      name: "Employer",
      icon: <BsFillBuildingsFill />,
      exact: true,
    },
    arraysHaveSimilarElements(adminAccessList, jobList) && {
      path: "/JobsTabsview",
      name: "Jobs",
      icon: <BsFillBriefcaseFill />,
      exact: true,
    },
    (isSuperAdmin ) && {
      path: "/InvoiceTabView",
      name: "Invoice",
      icon: <MdSendToMobile />,
      exact: true,
    },
    // {
    //   path: "/Bug/NewFeature",
    //   name: "Raise Ticket ",
    //   icon: <VscDebugConsole />,
    //   exact: true,
    // },
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [redDot, setRedDot] = useState(true);
  const [isRotating, setIsRotating] = useState(false);
  const Dispatch = useDispatch();
  // const location = useLocation();
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const getNewNotify = useSelector(
    (state) => state.CandidatePipelineDetails.memberNotify
  );
  // console.log(getNewNotify, "getNewNotify");

  useEffect(() => {
    if (getNewNotify === true) {
      setRedDot(true);
      // console.log("testing.....");
    } else {
      setRedDot(false);
    }
  }, [getNewNotify]);

  const showAnimation = {
    hidden: {
      width: 0,
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
    show: {
      opacity: 1,
      width: "auto",
      transition: {
        duration: 0.5,
      },
    },
  };
  // eslint-disable-next-line no-unused-vars
  const [auth, setAuth] = useState(true);
  const [pageTitle, setPageTitle] = useState("");
  const [targetData, setTargetData] = useState({
    tartgetAmount: "",
    AchiveAmount: "",
  });
  const location = useLocation();
  const navigate = useNavigate();
  const hash = window.location.hash;
  useEffect(() => {
    const path = location.pathname;
    const hash = location.hash;
    switch (path) {
      case "/Dashboard":
        setPageTitle("Analytics ");
        break;
      case "/profile_Dashboard":
        setPageTitle("Profile Dashboard");
        break;
      case "/job_filter":
        setPageTitle("Jobs");
        break;
      case "/CandidateTabsview":
        setPageTitle("Candidates");
        break;
        
      case "/EmployerTabsview":
        setPageTitle("Employers");
        break;
      case "/InvoiceTabView":
        setPageTitle("Invoice");
        break;
      case "/profile_page":
        setPageTitle("Profile Details");
        break;
      case "/fbmeta":
        setPageTitle("FB Meta Leads");
        break;
      case "/Job_lead":
        setPageTitle("Job Leads");
        break;
      case "/interview_schedule_list":
        setPageTitle("Scheduled Interviews");
        break;
      case "/Can_Lead":
        setPageTitle("Candidate Leads");
        break;
      case "/JS_Call_Registry":
        setPageTitle("Candidate Call Registry");
        break;
      case "/employer_leads":
        setPageTitle("Employer Leads");
        break;

      case "/invoice_List":
        setPageTitle("Proforma Invoice");
        break;
      case "/Employer_Payment":
        setPageTitle("Employer Payment");
        break;
      case "/EmployerUnpuplished":
        setPageTitle("Unpublished Jobs");
        break;
      case "/Emp_Registry":
        setPageTitle("Employer Call Registry");
        break;
      case "/Employer_Enquiries":
        setPageTitle("Employer Enquiry");
        break;
      case "/JobsTabsview":
        setPageTitle("Jobs");
        break;
      case "/employer_field_leads":
        setPageTitle("Employer Field Leads");
        break;
      case "/Midelevelseniorpostform":
        setPageTitle("Senior Candidate Details");
        break;
      case "/MidLevelSenior":
        setPageTitle("Senior Candidate");
        break;
      // case "/Bug/NewFeature":
      //   setPageTitle("Raise Ticket / New Feature");
      //   break;
      case "/CandidatePipeline":
        setPageTitle("Candidate Pipeline");
        break;
      case "/Interview_FollowUp1_Pipeline":
        setPageTitle("Interview Followup1 Pipeline");
        break;
      case "/CandidatePipelineTab":
        setPageTitle("Candidate Pipline");
        break;

        case "/NewCandidatePipelineTab":
        setPageTitle("New Candidate Pipline");
        break;
        //   case "/NewFollowUp":
        // setPageTitle("Follow Up's");
        // break;
      case "/AttendingLead":
        setPageTitle("Interview Attending Pipeline");
        break;
      case "/interviewStatus":
        setPageTitle("Interview Attended Pipeline");
        break;
      case "/workingprogress":
        if (hash === "#addUser") {
          setPageTitle("Add User");
        } else if (hash === "#addRole") {
          setPageTitle("Add Role");
        } else {
          setPageTitle("Working Progress");
        }
        break;
      default:
        setPageTitle("");
        break;
    }
  }, [location.hash, location.pathname]);
  // hhi
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.altKey && event.key === "1") {
        handleRouteChange("/CandidateTabsview", "Candidates");
      } else if (event.altKey && event.key === "3") {
        handleRouteChange("/EmployerTabsview", "Employers");
      } else if (event.altKey && event.key === "4") {
        handleRouteChange("/JobsTabsview", "Jobs");
      } else if (event.altKey && event.key === "2") {
        handleRouteChange("/MidLevelSenior", "Senior Candidate");
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);
  useEffect(() => {
    console.log(mothlyTargetFilter, "hh");
  }, [mothlyTargetFilter]);
  const filterData = {
    adminId: decryptedAdminID() == 1 ? -1 : decryptedAdminID(),
    startDate:
      hash === "#adminsTarget"
        ? mothlyTargetFilter.startDate
        : dateFormate(
            new Date(new Date().getFullYear(), new Date().getMonth(), 1)
          ),
    endDate:
      hash === "#adminsTarget"
        ? mothlyTargetFilter.endDate
        : dateFormate(
            new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
          ),
    page: 1,
  };
  useEffect(() => {
    getTargetData(filterData).then((data) => {
      const targetList = data?.result?.target ?? [];

      if (decryptedAdminID() == 1) {
        // Super admin: calculate total across all entries
        let totalTargetAmount = 0;
        let totalAchievedAmount = 0;

        targetList.forEach((el) => {
          totalTargetAmount += parseFloat(el.target_amount || 0);
          totalAchievedAmount += parseFloat(el.total_ctc || 0);
        });

        setTargetData((prev) => ({
          ...prev,
          tartgetAmount: totalTargetAmount,
          AchiveAmount: totalAchievedAmount,
        }));
      } else {
        // Normal admin: only show their own target
        const currentAdminId = Number(decryptedAdminID());
        const currentAdminTarget = targetList.find(
          (el) => el.admin_id === currentAdminId
        );

        setTargetData((prev) => ({
          ...prev,
          tartgetAmount: parseFloat(currentAdminTarget?.target_amount || 0),
          AchiveAmount: parseFloat(currentAdminTarget?.total_ctc || 0),
        }));
        // console.log(currentAdminTarget, targetList, "currentAdminTarget");
      }
    });
  }, [mothlyTargetFilter, hash]);

  const fetchData = () => {
    setIsRotating(true);
    getTargetData(filterData).then((data) => {
      const targetList = data?.result?.target ?? [];

      if (decryptedAdminID() == 1) {
        // Super admin: calculate total across all entries
        let totalTargetAmount = 0;
        let totalAchievedAmount = 0;

        targetList.forEach((el) => {
          totalTargetAmount += parseFloat(el.target_amount || 0);
          totalAchievedAmount += parseFloat(el.total_ctc || 0);
        });

        setTargetData((prev) => ({
          ...prev,
          tartgetAmount: totalTargetAmount,
          AchiveAmount: totalAchievedAmount,
        }));
      } else {
        // Normal admin: only show their own target
        const currentAdminId = Number(decryptedAdminID());
        const currentAdminTarget = targetList.find(
          (el) => el.admin_id === currentAdminId
        );

        setTargetData((prev) => ({
          ...prev,
          tartgetAmount: parseFloat(currentAdminTarget?.target_amount || 0),
          AchiveAmount: parseFloat(currentAdminTarget?.total_ctc || 0),
        }));
        // console.log(currentAdminTarget, targetList, "currentAdminTarget");
      }
    });
    setTimeout(() => {
      setIsRotating(false);
    }, 1000);
  };

  const handleRouteChange = (path, title) => {
    navigate(path);

    setPageTitle(title);
  };

  function HandleLogOut() {
    localStorage.clear();
    window.location.reload();
  }
  function TablehandleClose() {
    setOpenTeamList(false);
  }
  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <div className={`${style.main_container} `}>
      <motion.div
        animate={{
          width: isOpen ? "250px" : "45px",

          transition: {
            duration: 0.5,
            type: "spring",
            damping: 10,
          },
        }}
        className={`sidebar `}
      >
        <div
          className={` vh-100 ${style.sidebar} `}
          style={{ position: "fixed" }}
        >
          <Box>
            <AppBar
              className={`${style.AppBar}`}
              sx={{
                backgroundColor: "white",
                color: "black",
                zIndex: -1,
              }}
            >
              <Toolbar>
                <>
                  <Typography
                    variant=""
                    component="div"
                    sx={{ marginLeft: "30px", flexGrow: 1.5 }}
                  >
                    {/* {!isSuperAdmin && ( */}
                    <div
                      style={{
                        display: "inline-block",
                        // width: "300px",
                        // backgroundColor: "#02c04124",
                        // padding: "5px",
                        // borderRadius: "10px",
                        // border: "2px solid #169c50",
                      }}
                    >
                      {/* Target Amount */}
                      <div className="d-flex align-items-center justify-content-start gap-2">
                        <div
                          style={{ fontWeight: "bold", marginBottom: "5px" }}
                        >
                          Target:
                        </div>
                        <div>
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              fetchData();
                            }}
                          >
                            {" "}
                            <HiOutlineRefresh
                              className={`${
                                isRotating
                                  ? style.refreshRotate
                                  : style.refreshcolor
                              }`}
                            />
                          </span>
                        </div>
                        <div style={{ fontSize: "12px" }}>
                          {" "}
                          <b>₹ 0</b>{" "}
                        </div>

                        {(() => {
                          const target = Number(targetData.tartgetAmount);
                          const achieved = Number(targetData.AchiveAmount);
                          const percentage = target
                            ? Math.min((achieved / target) * 100, 100)
                            : 0;

                          return (
                            <div
                              style={{ position: "relative", width: "200px" }}
                            >
                              {/* Progress Bar */}
                              <div style={{
                                    position: "absolute",
                                    left: `calc(${percentage}% - 1px)`,
                                    top: "-15px",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    transform: "translateX(-50%)",
                                    fontSize: "10px",
                                    color: `${getPercentageColor(percentage, "dark")}`,
                                  }}>
                                 <b>
                                  {percentage.toFixed(2)}%
                                  </b> 
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  height: "12px",
                                  borderRadius: "8px",
                                  overflow: "hidden",
                                  background: "#e0e0e0",
                                  position: "relative",
                                }}
                              >
                                
                                <div
                                  style={{
                                    width: `${percentage}%`,
                                    backgroundColor: `${getPercentageColor(percentage, "dark")}`,
                                    transition: "width 0.5s ease-in-out",
                                  }}
                                ></div>
                                <div
                                  style={{
                                    width: `${100 - percentage}%`,
                                    backgroundColor: "#ccc",
                                  }}
                                ></div>
                              </div>

                              {/* Marker Line + Down Arrow + Amount */}
                              {targetData.AchiveAmount != 0 && (
                                <div
                                  style={{
                                    position: "absolute",
                                    left: `calc(${percentage}% - 1px)`,
                                    top: "0px",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    transform: "translateX(-50%)",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "1px",
                                      height: "12px",
                                      background: "#169c50",
                                    }}
                                  ></div>
                                  <div
                                    style={{
                                      fontSize: "10px",
                                      lineHeight: "0.5",
                                      color: "#169c50",
                                    }}
                                  >
                                    ▼
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "10px",
                                      backgroundColor: "#fff",
                                      padding: "2px 4px",
                                      borderRadius: "4px",
                                      boxShadow: "0 0 3px rgba(0,0,0,0.2)",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    <b>
                                      ₹{" "}
                                      {Number(
                                        targetData.AchiveAmount
                                      ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}
                                    </b>
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })()}

                        <div style={{ fontSize: "12px" }}>
                          <b>
                            ₹{" "}
                            {targetData.tartgetAmount
                              ? Number(targetData.tartgetAmount).toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )
                              : 0}
                          </b>
                        </div>
                      </div>
                      {/* Achieved Amount with balance */}
                      {/* <div className="d-flex align-items-center justify-content-center gap-2">
                          {targetData.tartgetAmount &&
                            targetData.AchiveAmount && (
                              <>
                                <div
                                  style={{
                                    fontWeight: "bold",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Achieved:{" "}
                                </div>
                                <div style={{ fontSize: "12px" }}>₹ 0</div>

                                <div style={{ fontSize: "12px" }}>
                                  
                                </div>
                              </>
                            )}
                        </div> */}
                      {/* {targetData.tartgetAmount &&
                          targetData.AchiveAmount && (
                            <div>
                              <div
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: "5px",
                                }}
                              >
                                Achieved Amount:
                              </div>
                              <div style={{ marginBottom: "4px" }}>
                                <b>
                                  {Number(
                                    targetData.AchiveAmount
                                  ).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </b>
                              </div>
                            </div>
                          )} */}
                    </div>
                    {/* )} */}
                  </Typography>
                  <Typography sx={{ flexGrow: 1, fontFamily: "sans-serif" }}>
                    <div className={`${style.pageTitle}`}>{pageTitle}</div>
                  </Typography>
                </>
                {auth && (
                  <Box sx={{ flexGrow: 0 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2, // Adjust the gap (spacing) between elements as needed
                      }}
                    >
                      <ToggleSwitch label=" " />
                      {/* {isTeamLeader == "true" && (
                        <>
                          <div style={{ position: "relative" }}>
                            <div
                              className={`${
                                redDot
                                  ? style.teamMemberViewRed
                                  : style.teamMemberView
                              }`}
                              onClick={() => {
                                Dispatch(
                                  CandidatePipelineActions.setMemberNotify(
                                    false
                                  )
                                );
                                setOpenTeamList(true);
                              }}
                            >
                              <FaChalkboardUser title="My Team Actions" />
                            </div>
                            {redDot && (
                              <p
                                style={{
                                  position: "absolute",
                                  top: "0px",
                                  // left: "0px",
                                  right: "0px",
                                  backgroundColor: "red",
                                  width: "8px",
                                  height: "8px",
                                  borderRadius: "50%",
                                }}
                              ></p>
                            )}
                          </div>
                        </>
                      )} */}
                      {/* <IconButton
                        size="large"
                        aria-label="show 17 new notifications"
                        color="inherit"
                        className="Notification"
                      >
                        <Notification />
                      </IconButton> */}
                      <Tooltip title="Open settings">
                        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                          <Avatar
                            src={ProfilePic}
                            // sx={{ width: 500, height: 400 }}
                          >
                            {/*  */}

                            {adminDetails.userName.charAt(0)}
                          </Avatar>
                        </IconButton>
                      </Tooltip>
                      <Menu
                        sx={{ mt: "45px" }}
                        id="menu-appbar"
                        anchorEl={anchorElUser}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        open={Boolean(anchorElUser)}
                        onClose={handleCloseUserMenu}
                      >
                        <Link
                          style={{ textDecoration: "none", color: "black" }}
                          to={{ pathname: "/profile_page" }}
                        >
                          <MenuItem
                            // className={classes.menuItem}
                            onClick={handleCloseUserMenu}
                          >
                            Profile Details
                          </MenuItem>
                        </Link>
                        {/* {!isSuperAdmin && (
                          <Link
                            style={{ textDecoration: "none", color: "black" }}
                            to={{ pathname: "/daily-analytics" }}
                          >
                            <MenuItem
                              // className={classes.menuItem}
                              onClick={handleCloseUserMenu}
                            >
                              Daily Analytics
                            </MenuItem>
                          </Link>
                        )} */}
                        <MenuItem
                          // className={classes.menuItem}
                          onClick={() => HandleLogOut()}
                        >
                          Logout
                        </MenuItem>
                      </Menu>
                    </Box>
                  </Box>
                )}
              </Toolbar>
            </AppBar>
          </Box>{" "}
          <div style={{ backgroundColor: "rgb(52, 51, 51)", color: "white" }}>
            <div
              className="d-flex "
              style={{
                backgroundColor: "rgb(52, 51, 51)",
                color: "white",
                height: isOpen ? "10vh" : "5vh",
                position: "sticky",
                top: "0",
                zIndex: 1,
              }}
            >
              <div className={`mt-2 ${style.top_section}`}>
                <AnimatePresence>
                  {isOpen && (
                    <motion.div
                      variants={showAnimation}
                      initial="hidden"
                      animate="show"
                      exit="hidden"
                      className="logo"
                    >
                      <img src={Taizologo} alt="Taizo-logo" className=" mx-3" />
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
              <div className={style.bars} onClick={toggleSidebar}>
                {isOpen ? (
                  <FaAngleLeft className="fs-3" />
                ) : (
                  <FaAngleRight className="fs-3 ms-2" />
                )}
              </div>
            </div>
            <section className={`${style.routes}`}>
              {routes.map((route, index) => {
                if (route.subRoutes) {
                  return (
                    <SidebarMenu
                      setIsOpen={setIsOpen}
                      route={route}
                      showAnimation={showAnimation}
                      isOpen={isOpen}
                    />
                  );
                }
                return route.externalLink ? (
                  <a
                    href={route.externalLink}
                    key={index}
                    className={`text-white ${style.link}  `}
                    target={route.target || "_blank"}
                  >
                    {isOpen ? (
                      <div className={`${style.icon}`}>{route.icon}</div>
                    ) : (
                      <Tooltip title={route.name} key={index}>
                        {route.icon}
                      </Tooltip>
                    )}
                    <AnimatePresence>
                      {isOpen ? (
                        <motion.div
                          variants={showAnimation}
                          initial="hidden"
                          animate="show"
                          exit="hidden"
                          className={`${style.link_text} `}
                        >
                          {route.name}
                        </motion.div>
                      ) : (
                        <Tooltip title={route.name} key={index}>
                          {route.icon}
                        </Tooltip>
                      )}
                    </AnimatePresence>
                  </a>
                ) : (
                  route && (
                    <NavLink
                      to={route.path}
                      key={index}
                      className={`text-white ${style.link}
                      `}
                    >
                      {isOpen ? (
                        <div className={`${style.icon}`}>{route.icon}</div>
                      ) : (
                        ""
                      )}
                      <AnimatePresence>
                        {isOpen ? (
                          <motion.div
                            variants={showAnimation}
                            initial="hidden"
                            animate="show"
                            exit="hidden"
                            className={`${style.link_text} `}
                          >
                            {route.name}
                          </motion.div>
                        ) : (
                          <CustomWidthTooltip
                            title={route.name}
                            // className="p-2"

                            placement="right-start"
                            key={index}
                          >
                            {/* <NavLink
                              to={route.path}
                              className={`text-white ${style.link}`}
                            > */}
                            <div
                              className={`${style.icon}`}
                              style={{ cursor: "pointer" }}
                            >
                              {route.icon}
                            </div>
                            {/* </NavLink> */}
                          </CustomWidthTooltip>
                        )}
                      </AnimatePresence>
                    </NavLink>
                  )
                );
              })}
            </section>
          </div>
        </div>
      </motion.div>
      {openTeamList && (
        <>
          <MyModal>
            <ModalContainer
              childComponent={
                <>
                  <div
                    style={{
                      width: "800px",
                    }}
                  >
                    <div>
                      {/* <TeamMemberActionList onClose={TablehandleClose} /> */}
                      <TeamMemberActionTable onClose={TablehandleClose} />
                    </div>
                  </div>
                </>
              }
            />
          </MyModal>
        </>
      )}
      <main style={{ marginTop: 60, width: 1500 }}>{children} </main>
    </div>
  );
};

export default SideNavbar;
